<template>
    <div class="text-primary mb-4">
        <div class="d-flex align-items-center gap-0-5 mb-3">
            <img
                height="20"
                :src="require('@/assets/img/drs/rvm-device.svg')"
            >
            <span>
                Butelkomat
                <strong v-text="configuration.device.producer_name || '---'" />
                ({{ configuration.mcuid }})
                zintegrowany z operatorem
                <strong v-text="configuration.operator?.name || '---'" />
            </span>
        </div>

        <config-mode-section
            section-key="package_fraction_mode"
            :options="options"
            @change="onModeChange"
        />

        <div class="d-flex justify-content-end">
            <the-btn
                class="btn-secondary"
                text="Zapisz"
                :disabled="!isConfigChanged || isBtnLoader"
                :icon="isBtnLoader ? 'Spinner' : ''"
                :loading-status="isBtnLoader ? 'loading' : 'idle'"
                @click="save"
            />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CONFIG_MODES, STORE_CONFIG } from '@/utils/constants/drs/store-config'

export default {
    props: {
        configuration: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            isBtnLoader: false,
            selectedMode: this.configuration.package_fraction_mode
        }
    },

    computed: {
        options() {
            return STORE_CONFIG[CONFIG_MODES.PACKAGE_FRACTION].map(option => ({
                ...option,
                id: option.mode,
                label: option.title,
                isActive: option.mode === this.selectedMode
            }))
        },

        isConfigChanged() {
            return this.selectedMode && this.selectedMode !== this.configuration.package_fraction_mode
        }
    },
    methods: {
        ...mapActions('drsConfiguration', ['saveAutomaticConfiguration']),

        onModeChange({ modeId }) {
            this.selectedMode = modeId
        },

        async save() {
            this.isBtnLoader = true
            try {
                await this.saveAutomaticConfiguration({
                    mcuid: this.configuration.mcuid,
                    package_fraction_mode: this.selectedMode
                })
            } finally {
                this.isBtnLoader = false
            }
        }
    }
}
</script>
